import { cn } from '@/shared/lib/cn';

import { MioArtifactView, MioSources } from './mio-artifact';
import { MioMarkdown } from './mio-markdown';

import type { MioAgentMessage } from '@mio/shared';

/** The conversation: Mio speaks in the open, the learner's words sit on a soft surface. */
export function MioTranscript({ messages }: { messages: MioAgentMessage[] }) {
  const lastDiagramMessage = messages.findLastIndex(
    (message) =>
      message.role === 'mio' && message.artifacts.some((item) => item.type === 'diagram'),
  );
  return (
    <ol className="space-y-6">
      {messages.map((m, messageIndex) => {
        const mio = m.role === 'mio';
        return (
          <li
            key={m.id}
            className={cn(
              'flex min-w-0 flex-col [overflow-wrap:anywhere]',
              !mio && 'items-stretch',
            )}
          >
            {mio ? (
              <>
                <span className="text-mio text-xs font-semibold">Mio</span>
                <div className="mt-2 w-full">
                  <MioMarkdown source={m.content} />
                  {m.artifacts.map((artifact, index) => (
                    <MioArtifactView
                      key={artifact.id}
                      artifact={artifact}
                      hasLaterDiagram={
                        messageIndex < lastDiagramMessage ||
                        m.artifacts.slice(index + 1).some((later) => later.type === 'diagram')
                      }
                    />
                  ))}
                  <MioSources sources={m.sources} />
                  {m.status === 'interrupted' ? (
                    <p className="text-fg-subtle mt-2 text-[12px]">Interrupted</p>
                  ) : null}
                  {m.status === 'failed' ? (
                    <p className="text-danger mt-2 text-[12px]">Reply could not finish</p>
                  ) : null}
                </div>
              </>
            ) : (
              <div className="bg-mio-soft border-mio-line text-fg max-w-full rounded border px-3 py-3 text-[15px] leading-[1.65]">
                <span className="text-fg-muted mb-1 block text-xs font-semibold">You</span>
                <span className="whitespace-pre-wrap">{m.content}</span>
                {m.modality === 'voice' ? (
                  <span className="text-fg-subtle mt-1 block text-[12px]">Voice transcript</span>
                ) : null}
                {m.status === 'failed' ? (
                  <span className="text-danger mt-1 block text-[12px]">Not sent</span>
                ) : null}
                {m.status === 'queued' ? (
                  <span className="text-fg-subtle mt-1 block text-[12px]">
                    Sends when Mio finishes the current reply
                  </span>
                ) : null}
              </div>
            )}
          </li>
        );
      })}
    </ol>
  );
}
